const initialState = {
    isBankVerified : false,
    isPANverified : false,
    accountNumber : '',
    panNumber : ''
};

const VerifyBankReducer = (state=initialState , action) => {
    switch(action.type)
    {
        case "bank":
            return action.payload;
        case "pan":
            return action.payload;
        default :
            return initialState;
    }
}
export default VerifyBankReducer;
